import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, PLATFORM_ID, ChangeDetectorRef, DOCUMENT } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Product } from '../models/product.model'; 
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';
import { homeclips } from '../interfaces/data/homeclips';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FooterComponent } from '../footer/footer.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [MrpScrolltopComponent, MatIconButton, MatIcon, RouterLink, FooterComponent]
})
export class HomeComponent implements OnInit, AfterViewInit  {

  @ViewChild('floatingVideo') floatingVideoRef!: ElementRef<HTMLVideoElement>;


  isMuted = true;
  bannerVidVisible = true;
  videoSrc = '';
  isBrowser: boolean;
  isHydrated = false;
  videoLoaded = false;
  // true while we're trying to programmatically start playback so the video
  // can become visible immediately (necessary for user-gesture/autoplay flows)
  attemptingPlay = false;

  // Tracks whether the user has already interacted with the banner video.
  // On the first interaction we rewind the video to 0 and unmute; subsequent
  // interactions toggle audio only.
  videoInteracted = false;

  // Whether the video is currently playing and whether it has reached ended
  isPlaying = false;
  videoEnded = false;

  products: Product[] = [];
  displayedColumns: string[] = ['name', 'description', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  initiatingCheckoutStates: { [key: string]: boolean } = {};

  constructor(private http: HttpClient, private router: Router, private dialog: MatDialog, 
              @Inject(PLATFORM_ID) private platformId: Object, 
              private cdr: ChangeDetectorRef,
              private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) { 
    
    this.isBrowser = isPlatformBrowser(this.platformId);

  }

  ngOnInit(): void {

    const randomIndex = Math.floor(Math.random() * homeclips.length);
    this.videoSrc     = homeclips[randomIndex].src;

    this.isLoading = true;
    this.http.post<Product[]>('api/products/getAllClasses.php', {}).subscribe({
        next: (data) => {
          this.products = data;
          //console.log('Fetched class dates:', data);
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          if(this.isBrowser){
            console.error('Error fetching class dates:', error);
            this.isLoading = false;
            this.cdr.markForCheck();
          }
        }
      });

    //   this.logPage('home');

  }

  logPage(urlName: string): void {
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }

  ngAfterViewInit(): void {
    // mark hydrated only in real browser so SSR output stays with the image placeholder
    if (isPlatformBrowser(this.platformId)) {
      this.isHydrated = true;

      // Indicate we intend to attempt playback immediately so the video
      // becomes visible (removes the `hidden` attribute in the template)
      this.attemptingPlay = true;

      // Ensure the <video> element is rendered and attributes reflect attemptingPlay
      this.cdr.detectChanges();

      // Attempt muted autoplay (browsers usually allow muted autoplay)
      this.tryPlayVideo();

    }
  }

  isInitiating(priceId: string): boolean {
    return this.initiatingCheckoutStates[priceId] || false;
  }

  async initiateCheckout(priceId: string, mode: 'payment' | 'subscription') {

    let checkoutURL = 'api/create-checkout-session/create-checkout-session.php';

    this.initiatingCheckoutStates[priceId] = true; // Set the initiating state for the specific priceId
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string }>(checkoutURL, { priceId, mode }).subscribe(
      async (response) => {
        // Redirect to Stripe Checkout
        window.location.assign(response.sessionUrl);
      },
      (error) => {
        this.initiatingCheckoutStates[priceId] = false;
        console.error('Error creating checkout session:', error);
        this.cdr.markForCheck();
      }
    );
  }

    gotoClass(item_CODE: string){

      const classType = item_CODE.substring(0,4);

      switch(classType){
        case 'RRBC':
          this.router.navigate(['/bootcamp-detail', item_CODE]); 
          break;
        case 'RRZC': 
          this.router.navigate(['/zoom-detail', item_CODE]); 
          break;
        case 'RRZA':
          this.router.navigate(['/adv-detail', item_CODE]); 
          break;

      }      
  }

  openVideoPlayer(index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false; 
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80vw'; 
    dialogConfig.height = '70vh'; 

    // ✅ Pass the index using the `data` property 
    // THIS IS AN INPUT TO VideoDialogComponent
    dialogConfig.data = { videoIndex: index };

    this.bannerVidVisible = false; 

    this.dialog.open(VideoDialogComponent, dialogConfig);
  }

  toggleAudio(videoEl: HTMLVideoElement | null) {
    // If placeholder was clicked, insert the video and play with sound
    if (!videoEl) {
      this.onPlaceholderClick(true);
      this.videoInteracted = true;
      return;
    }

    try {
      // Treat the first interaction OR a click after the video ended as a
      // rewind-and-play-unmuted gesture (must be inside user gesture to allow audio)
      if (!this.videoInteracted || videoEl.ended) {
        videoEl.currentTime = 0;
        videoEl.muted = false;
        videoEl.volume = 1.0;

        videoEl.play().then(() => {
          this.videoLoaded = true;
          this.isPlaying = true;
          this.videoEnded = false;
        }).catch(err => {
          console.warn('toggleAudio: rewind/unmute/play failed', err);
        });

        this.isMuted = false;
        this.videoInteracted = true;
        return;
      }

      // If the video is currently playing, toggle mute on/off
      if (!videoEl.paused && !videoEl.ended) {
        if (videoEl.muted) {
          videoEl.muted = false;
          videoEl.volume = 1.0;
          this.isMuted = false;
        } else {
          videoEl.muted = true;
          videoEl.volume = 0;
          this.isMuted = true;
        }
        return;
      }

      // For any other case (paused but not ended), unmute and ensure playback
      if (videoEl.muted) {
        videoEl.muted = false;
        videoEl.volume = 1.0;
        this.isMuted = false;
      }
      if (videoEl.paused) {
        videoEl.play().then(() => {
          this.isPlaying = true;
        }).catch(err => console.warn('toggleAudio: play after pause failed', err));
      }

    } catch (e) {
      console.warn('toggleAudio: error handling click', e);
    }
  }


  // Called when the video fires its loadeddata event
  onVideoLoaded() {
    this.videoLoaded = true;
    this.attemptingPlay = false;

    // If we can inspect the element, set playing/ended flags
    const v = this.floatingVideoRef?.nativeElement ?? document.querySelector('video.floating-video') as HTMLVideoElement | null;
    if (v) {
      this.isPlaying = !v.paused && !v.ended;
      this.videoEnded = !!v.ended;
    }
  }

  // Called when the video fires an error event
  onVideoError(ev?: Event) {
    this.videoLoaded = false;
    this.attemptingPlay = false;

    // Keep placeholder visible and optionally retry later
    this.bannerVidVisible = true;
  }

  // User clicked the placeholder image: hydrate and attempt to play video
  // placeholderClicked indicates the click was a direct user gesture wanting sound
  onPlaceholderClick(placeholderClicked = false) {
      // Ensure we are marked hydrated so the <video> is inserted into the DOM
    this.isHydrated = true;

    // Show the video element immediately
    this.attemptingPlay = true;

    // Force synchronous change detection so we can access the video element
    // within the same user gesture (important for autoplay/unmute policies)
    this.cdr.detectChanges();

    // If the element exists now, try to play and (on user click) unmute
    const videoEl = (this.floatingVideoRef?.nativeElement ?? document.querySelector('video.floating-video')) as HTMLVideoElement | null;
    if (videoEl) {
      // If this was a direct user click, unmute so sound will play
      if (placeholderClicked) {
        videoEl.muted = false;
        videoEl.volume = 1;
        this.videoInteracted = true;
      }

      videoEl.play().then(() => {
        if (videoEl.readyState >= 2) {
          this.videoLoaded = true;
        }
        this.attemptingPlay = false;
        this.isMuted = !!videoEl.muted;
        this.isPlaying = true;
        this.videoEnded = false;
      }).catch(err => {
        console.warn('onPlaceholderClick: play failed, will retry silently (muted)', err);
        // Fallback to muted attempt so the video still shows and can be unmuted by user
        videoEl.muted = true;
        videoEl.play().then(() => {
          this.isPlaying = true;
        }).catch(() => {});
        this.attemptingPlay = false;
        this.isMuted = true;
        this.videoEnded = false;
      });

      return;
    }

    // Fallback if we couldn't find the video element: try the normal muted autoplay path
    this.tryPlayVideo();
  }

  private tryPlayVideo(retry = 0) {
    // first try the ViewChild reference
    let video: HTMLVideoElement | null = this.floatingVideoRef?.nativeElement ?? null;

    // fallback: query the DOM directly (useful when ViewChild hasn't bound yet)
    if (!video && this.isBrowser) {
      video = document.querySelector('video.floating-video');
    }

    if (!video) {
      return;
    }

     // We're attempting playback now — show the video element while we try
    this.attemptingPlay = true;
    this.videoLoaded = false;

    // Ensure attributes favorable for muted autoplay
    video.preload = 'auto';
    video.autoplay = true;
    video.muted = true;
    video.loop = false;
    // ensure the browser begins loading media
    try { video.load(); } catch (e) {
      /* ignore */
    }

    // Call play() — handle rejection and retry a couple times for flaky environments
    video.play().then(() => {
      if (video!.readyState >= 2) {
        this.videoLoaded = true;
      }
      this.attemptingPlay = false;
      this.isPlaying = true;
      this.videoEnded = false;
    }).catch(err => {
      console.warn(`tryPlayVideo: play() rejected on attempt=${retry}`, err);

      // Retry once or twice for flaky environments (muted autoplay frequently
      // succeeds on a short retry after resources begin loading)
      if (retry < 2) {
        setTimeout(() => this.tryPlayVideo(retry + 1), 200);
        return;
      }

      this.attemptingPlay = false;
      // loadeddata or error events will handle state after this
    });

    // Extra safety: if the video is already in a loaded state
    if (video.readyState >= 2) {
      this.videoLoaded = true;
      this.attemptingPlay = false;
    }
  }

  // Called when the video playback reaches the end
  onVideoEnded() {
    this.isPlaying = false;
    this.videoEnded = true;
    // leave videoLoaded true so the element remains visible
  }

}
